export default "__VITE_ASSET__BTlw4BaP__"